import { render } from "./FormCarouselSlide.vue?vue&type=template&id=166fccf9"
import script from "./FormCarouselSlide.vue?vue&type=script&lang=js"
export * from "./FormCarouselSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__